import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { dbToString } from "@dffedb/util";
import { UmbracoHttpClient } from "@e-forsyning/common/http";

import { FeatureNoterIndstillingerDto } from "../model/feature-noter-indstillinger.dto";
import { FeatureNoterIndstillinger } from "../model/feature-noter-indstillinger.model";

@Injectable({ providedIn: "root" })
export class FeatureNoterRepository {
    constructor(private readonly umbracoHttp: UmbracoHttpClient) {}

    public hentIndstillinger(): Observable<FeatureNoterIndstillinger> {
        return this.umbracoHttp.hentSideData<FeatureNoterIndstillingerDto>("noter").pipe(map((data) => this.mapDtoToIndstillinger(data)));
    }

    private mapDtoToIndstillinger(dto: FeatureNoterIndstillingerDto): FeatureNoterIndstillinger {
        return {
            sideTitel: dbToString(dto.menuTekst)
        };
    }
}
